(function() {
  'use strict';

  angular.module('app.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('mail', {
        url: '/mail',
        templateProvider: function($templateCache) {
          return $templateCache.get('modules/mail/mail.html');
        },
        title: 'Mail',
        controller: 'MailController',
        controllerAs: 'vm',
        sidebarMeta: {
          icon: 'ion-email',
          order: 260,
          roles: ['admin', 'inspector'],
        },
      });
  }
})();
